import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// /login redirects to student login by default
function Login() {
  const navigate = useNavigate();
  useEffect(() => { navigate('/login/student', { replace: true }); }, [navigate]);
  return null;
}

export default Login;
